import React from 'react';
import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { tokens } from '../../theme/tokens';

interface Props {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

/** The title of every card on the home and Planning pages: one size, one weight. */
export const CardTitle: React.FC<Props> = ({ children, sx }) => (
  <Typography
    component="h2"
    sx={[{ fontFamily: tokens.display, fontSize: 17, fontWeight: 650, lineHeight: 1.3, m: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}
  >
    {children}
  </Typography>
);
